import useSWR from "swr";
import type { SwrReturnType } from "~/models/Api";
import type { CompanyWorkflowSetting } from "~/models/CompanyWorkflowSetting";
import { generatePath } from "~/utils/generatePath";

export const useCompanyWorkflowSettings = (): SwrReturnType<
	CompanyWorkflowSetting[]
> => {
	const { data, mutate, error, isLoading } = useSWR<CompanyWorkflowSetting[]>(
		generatePath("/company_workflow_settings")
	);
	return {
		data: data ?? null,
		error,
		isLoading,
		mutate
	};
};
